export const EMPTY_DECISION_TYPE_FORM = {
  name: '',
  description: '',
  branchId: '',
  status: 'active',
};

const DECISION_TYPE_SAMPLES = [
  {
    name: 'الموافقات المالية',
    description:
      'قرارات مرتبطة بالميزانيات والخطط الاستثمارية ونقل الاعتمادات والتزامات مالية مؤكدة بموجب نظام الشركات.',
  },
  {
    name: 'تعيين وإعفاء الإدارة التنفيذية',
    description:
      'تعيين المدير العام والنواب والرؤساء التنفيذيين وإعفائهم وتحديد صلاحياتهم ورواتبهم وفق لائحة الشركة.',
  },
  {
    name: 'الاستثمارات وشراكات المساهمين',
    description:
      'الموافقة على استحواذات أو مبيعات أصول جوهرية وإنشاء فروع وشراكات وتحديد حدود الصلاحيات الاستثمارية.',
  },
  {
    name: 'العقود والالتزامات الاستراتيجية',
    description:
      'الموافقة على عقود توريد وخدمات وتراخيص طويلة الأجل بما يتجاوز الحد المفوض لإدارة التنفيذ.',
  },
  {
    name: 'توزيعات الأرباح والسياسة التعادلية',
    description:
      'اعتماد سياسة التوزيعات والأرباح المتراكمة وبرامج إعادة شراء أسهم وما يتصل بمصالح المساهمين.',
  },
  {
    name: 'اللجان الدائمة ولوائح الحوكمة',
    description:
      'تشكيل لجان تدقيق ومخاطر وترشيحات واعتماد تحديثات لائحة العمل ولوائح السرية وإفصاحات الحوكمة.',
  },
];

/**
 * @param {string} branchId – selected company/branch id (required for save)
 * @returns {typeof EMPTY_DECISION_TYPE_FORM}
 */
export function getSampleDecisionTypeForm(branchId) {
  const n = Date.now();
  const tag = String(n).slice(-5);
  const s = DECISION_TYPE_SAMPLES[n % DECISION_TYPE_SAMPLES.length];
  return {
    name: `${s.name} — ${tag}`,
    description: s.description,
    branchId: branchId != null && branchId !== '' ? String(branchId) : '',
    status: 'active',
  };
}

const DEFAULT_MSG_AR = {
  nameRequired: 'اسم النوع مطلوب',
  branchRequired: 'الشركة مطلوبة',
};

/** @param {Record<string, string>} [messages] localized validation messages */
export function validateDecisionTypeForm(form, messages = {}) {
  const m = { ...DEFAULT_MSG_AR, ...messages };
  const errors = {};
  if (!form.name.trim()) errors.name = m.nameRequired;
  if (!form.branchId) errors.branchId = m.branchRequired;
  return errors;
}
